import React from 'react'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import { themeClassName } from 'lib/theme/themeUtils'
import { addDays, daysUntilDate } from 'lib/datetime/dateUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import useRenewalAction from 'luxPlus/hooks/useRenewalAction'
import { getLuxPlusSubscriptionRenewalDate } from 'selectors/luxPlusSelectors'
import { connect } from 'react-redux'
import { isPendingRenewalLuxPlusMember } from 'luxPlus/selectors/featureToggle'

interface MappedProps {
  subscriptionRenewalDate?: string
  isPendingRenewalLuxPlusMember: boolean
}

interface Props extends MappedProps {}

function LuxPlusRenewalMessageBanner({ subscriptionRenewalDate, isPendingRenewalLuxPlusMember }:Props) {
  const handleRenewal = useRenewalAction()
  if (!subscriptionRenewalDate || !isPendingRenewalLuxPlusMember) return null

  const renewalDate = new Date(subscriptionRenewalDate)
  const dateUntilLastRenewalAttempt = addDays(renewalDate, LUXURY_PLUS.RENEWAL_GRACE_PERIOD_IN_DAYS)
  const daysUntilLastRenewalAttempt = daysUntilDate(dateUntilLastRenewalAttempt)
  const daysString = daysUntilLastRenewalAttempt === 0 ? 'today' : `in ${pluralizeToString('day', daysUntilLastRenewalAttempt)}`

  return <MessageBanner
    className={themeClassName('default')}
    heading="Your payment was declined"
    description={`Your benefits are on hold until payment is completed. Renew now to continue enjoying ${LUXURY_PLUS.PROGRAM_NAME} pricing, bonus inclusions, early access & more. If payment is not received ${daysString} we will cancel your membership.`}
    kind="critical"
    primaryActionButtonProps={{ children: 'Renew membership', onClick: handleRenewal }}
  />
}

const mapStateToProps = (state: App.State): MappedProps => ({
  subscriptionRenewalDate: getLuxPlusSubscriptionRenewalDate(state),
  isPendingRenewalLuxPlusMember: isPendingRenewalLuxPlusMember(state),
})

export default connect(mapStateToProps)(LuxPlusRenewalMessageBanner)
